var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 23L1 2L17 12.2857L1 23Z","fill":"#000","stroke":"#000","strokeWidth":"1.6"}));
}

Component.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 19 25","fill":"none"};

module.exports = Component;

Component.default = Component;
